<template>
	<div class="message-wrap">
		<el-tabs class="tabs" v-model="activeTab" @tab-click="handleClick">
			<el-tab-pane label="收到的赞" name="1">
				<div v-if="dataList.length>0">
					<div v-for="item in dataList" @click="toDetail(item.linkRoute)">
						<commentItem :item="item"/>
					</div>
				</div>
				<Empty v-else content="还没有消息"/>
			</el-tab-pane>
			<el-tab-pane label="关注我的" name="2">
				<div v-if="dataList.length>0">
					<div v-for="item in dataList" @click="toDetail(item.linkRoute)">
						<commentItem :item="item"/>
					</div>
				</div>
				<Empty v-else content="还没有消息"/>
			</el-tab-pane>
		</el-tabs>
		<div v-if="total>pageSize">
			<Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
		</div>
	</div>
</template>

<script>
	import commentItem from '@/components/message/commentItem'
	import Empty from '@/components/empty'
	import Pagination from '@/components/pagination'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'likeFllow',
		components: {
			commentItem,
			Empty,
			Pagination
		},
		data(){
			return {
				activeTab: '1',
				pageSize: 10,
				pageNum: 1,
				dataList: [],
				total: 0,
				sendFlag: 1, //1我收到的    2我发出的  默认是是收到
				templateType: 'LIKE' //REPLY  回复 SYSTEM  系统 FOLLOW  关注 LIKE  点赞
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')||''
			this.getMessageList()
			this.getNumber()
		},
		methods: {
			async getNumber() {
				let param = {
					userId:  this.userId
				}
				ajaxParam(param)
				const res = await post('v1/message/getMessageUnreadCount', qs.stringify(param))
				if(res.data.code==200){
					let obj = res.data.entity
					this.numberComment = Number(obj.replyCount)
					this.numberSyetem = Number(obj.systemCount)
					this.numberLike = Number(obj.likeCount)
					console.log(this.numberComment)
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取消息列表
			async getMessageList(){
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					userId:  this.userId,
					sendFlag: this.sendFlag,
					templateType: this.templateType
				}
				ajaxParam(param)
				const res = await post('v1/message/messageList', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
      toDetail(url){
        window.open(url)
      },
			//获取数据列表
			async getDataList(){
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					userId:  this.userId
				}
				ajaxParam(param)
				const res = await post('v1/circle/fansList', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			pageChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getMessageList()
				this.getNumber()
			},
			handleClick(tab, event) {
				this.dataList = []
				this.pageNum = 1
				if(tab.name=='1') {
					this.templateType = 'LIKE'
				} else if(tab.name=='2') {
					this.templateType = 'FOLLOW'
				}
				this.getMessageList()
				this.getNumber()
			}
		}
	}
</script>

<style lang="less" scoped>

</style>
